export const getTagDialogOpen = (state) => state.tag.dialog.open;
export const getTagDialogSaving = (state) => state.tag.dialog.saving;
export const getTagLabel = (state) => state.tag.data.label;
